import {replaceText} from "@next/utils"
import {SUPPORTED_MY_ACCOUNT_TYPES} from "../../config/constants"
import {ElementModel} from "../../models/headerModel"

interface MyAccountQuicklinksProps {
    accessibilityText: string | null
    description: string | null
    icon: string | null
    myAccountText: string | null
    wideModeIcon: string | null
    narrowModeIcon: string | null
    url: string | null
}

const getMyAccountQuicklinks = (
    quickLinks: ElementModel[] | undefined,
    isLoggedIn: boolean,
    userUpdated: boolean,
    firstName: string,
): MyAccountQuicklinksProps => {
    if (!quickLinks) {
        return {
            accessibilityText: null,
            description: null,
            icon: null,
            myAccountText: null,
            wideModeIcon: null,
            narrowModeIcon: null,
            url: null,
        }
    }

    const reducedState: any = quickLinks.reduce((acc, next) => {
        if (next.type === SUPPORTED_MY_ACCOUNT_TYPES.loggedIn) {
            return {
                ...acc,
                loggedIn: {
                    ...next,
                    text: replaceText(next.text || "", firstName, /<username>/),
                    accessibilityText: replaceText(next.accessibilityText || "", firstName, /<username>/),
                    tooltip: replaceText(next.tooltip || "", firstName, /<username>/),
                    description: next.description,
                    url: next.url,
                },
            }
        }
        if (next.type === SUPPORTED_MY_ACCOUNT_TYPES.loggedOut) {
            return {
                ...acc,
                loggedOut: {...next, text: next.text, description: next.description, url: next.url},
                tooltip: "",
            }
        }
        return acc
    }, {})

    const result = isLoggedIn ? (reducedState.loggedIn as ElementModel) : (reducedState.loggedOut as ElementModel)
    const loggedInMyAccountText = userUpdated ? (reducedState.loggedIn.text as string) : ""
    const loggedOutMyAccountText = userUpdated ? (reducedState.loggedOut.text as string) : ""
    const {description, icon, accessibilityText, wideModeIcon, narrowModeIcon, url} = result as ElementModel
    const myAccountText: string = isLoggedIn ? loggedInMyAccountText : loggedOutMyAccountText

    return {accessibilityText, description, icon, myAccountText, wideModeIcon, narrowModeIcon, url}
}

export default getMyAccountQuicklinks
